import { concat, of } from 'rxjs';
import { mergeMap } from 'rxjs/operators';
import { IEpic, isTypeOfAndGetPayload } from '@cbridge-utils/redux-observable';
import { catchApiError } from '@cbridge-packages/api-base';
import { ICoverageApiDependencySegment } from '@cbridge-packages/api-coverage';
import { createApiErrorNotification } from '@cbridge-packages/notification';
import { CoverageAccountAction, CoverageAccountTranslator } from '@cbridge-packages/coverage-account';
import { CoverageReportAction } from '../coverageReport.action';
import { CoverageReportTranslator } from '../coverageReport.translator';

type IDependencies = ICoverageApiDependencySegment;

// GET /external-reporting/reports embeds each report's coverage accounts (there is no flat
// accounts endpoint), so this epic feeds BOTH stores: it mirrors the whole lifecycle into
// CoverageAccountAction.loadList so the account store's data and network status stay in
// sync with the single request.
export const loadCoverageReportListEpic: IEpic<{}, IDependencies> = (action$, _, { coverageApi }) => action$.pipe(
  isTypeOfAndGetPayload(CoverageReportAction.loadList.started),
  mergeMap(() => concat(
    of(CoverageAccountAction.loadList.started()),
    coverageApi.getCoverageReports().pipe(
      mergeMap((response) => {
        const reports = response.reports ?? [];
        const result = reports.map(CoverageReportTranslator.fromApi);
        const accounts = reports.flatMap((report) =>
          (report.accounts ?? []).map((account) => CoverageAccountTranslator.fromApi(account, report.id)));
        return [
          CoverageReportAction.loadList.done({ result }),
          CoverageAccountAction.loadList.done({ result: accounts }),
        ];
      }),
      catchApiError((error) => [
        CoverageReportAction.loadList.failed({ error }),
        CoverageAccountAction.loadList.failed({ error }),
        createApiErrorNotification(error),
      ]),
    ),
  )),
);
